<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import { App } from '@capacitor/app';

App.addListener('backButton', ({canGoBack}) => {
  /* if(!canGoBack){
    CapacitorApp.exitApp();
  } else {
    window.history.back();
  } */
  console.log('BACK');
});

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet
  }
});
</script>